import styled from 'styled-components';

export const AdBodyFormBottom = styled.div`
  grid-template-columns: 0.4fr 1fr;
  justify-content: center;
  align-items: center;
  display: grid;
  border-top: 1px solid #dce0e4;
  @media (max-width: 950px) {
    display: block;
  }
`;

export const AdBodyFormBottomLeft = styled.div`
  border-right: 1px solid #dce0e4;
  border-bottom-left-radius: 8px;
  background-color: #f2f4f6;
  justify-content: flex-start;
  align-items: center;
  padding-left: 40px;
  display: flex;

  height: 100%;
  @media (max-width: 950px) {
    width: unset;
  }
`;

export const AdBodyFormBottomRight = styled.div`
  justify-content: flex-start;
  padding: 20px 30px;
  display: flex;
  align-items: flex-end;
  & > div {
    margin-right: 10px;
  }
`;

export const AdBodyFormBottomRightLabel = styled.div`
  margin-left: 10px;
`;
export const AdBodyFormSearch = styled.div`
  padding: 10px 40px 5px 30px;
`;
